import React from 'react';
import '../../App.css';
import X from '../../assets/images/X_logo.svg';
import investments from '../../assets/images/investments_logo.svg';
import substack from '../../assets/images/substack_logo.svg';
import linkedin from '../../assets/images/linkedin_logo.svg';
import goodreads from '../../assets/images/goodreads_logo.svg';

function App() {
  return (
    <div className='app'>
      <header className='header'>
        <h1>Kelvin Yu</h1>
        <nav>
          <ul className='nav-links'>
            <li>
              <a
                href='https://twitter.com/kelvinotcelsius'
                target='_blank'
                rel='noopener noreferrer'
              >
                <img
                  src={X}
                  alt='X'
                  style={{ height: '1.2em', width: 'auto' }}
                />
              </a>
            </li>
            <li>
              <a
                href='https://kelvinotcelsius.substack.com'
                target='_blank'
                rel='noopener noreferrer'
              >
                <img
                  src={substack}
                  alt='Substack'
                  style={{ height: '1.2em', width: 'auto' }}
                />
              </a>
            </li>
            <li>
              <a
                href='https://www.linkedin.com/in/kelvinotcelsius/'
                target='_blank'
                rel='noopener noreferrer'
              >
                <img
                  src={linkedin}
                  alt='Linkedin'
                  style={{ height: '1.2em', width: 'auto' }}
                />
              </a>
            </li>
            <li>
              <a
                href='https://www.goodreads.com/kelvinotcelsius'
                target='_blank'
                rel='noopener noreferrer'
              >
                <img
                  src={goodreads}
                  alt='Goodreads'
                  style={{ height: '1.2em', width: 'auto' }}
                />
              </a>
            </li>
            <li>
              <a href='/angel' target='_blank' rel='noopener noreferrer'>
                <img
                  src={investments}
                  alt='Investments'
                  style={{ height: '1.2em', width: 'auto' }}
                />
              </a>
            </li>
          </ul>
        </nav>
      </header>
      <main>
        <section className='intro'>
          <p>
            I am building financial infrastructure to grow America's industrial
            GDP.
          </p>
          <p>
            I have been a 2x founding engineer, early-stage investor, and policy
            advisor in Congress. I studied CS at Princeton before dropping out.
          </p>
          <p>
            My work has been featured in:{' '}
            <a
              href='https://x.com/tbpn/status/1919845197812531463'
              target='_blank'
              rel='noopener noreferrer'
            >
              TBPN
            </a>
            ,{' '}
            <a
              href='https://commonplace.org/2025/05/06/americas-techno-industrial-crossroads/'
              target='_blank'
              rel='noopener noreferrer'
            >
              Commonplace
            </a>
            ,{' '}
            <a
              href='https://www.luxcapital.com/content/how-to-turn-around-americas-tech-industrial-decline-now'
              target='_blank'
              rel='noopener noreferrer'
            >
              Riskgaming
            </a>
            ,{' '}
            <a
              href='https://podcasts.apple.com/us/podcast/the-techno-industrial-policy-playbook-w-robert/id1528920211?i=1000714351607'
              target='_blank'
              rel='noopener noreferrer'
            >
              The Dynamist
            </a>
            ,{' '}
            <a
              href='https://americanaffairsjournal.org/2025/02/technological-progress-in-chinese-political-culture-an-intellectual-genealogy/'
              target='_blank'
              rel='noopener noreferrer'
            >
              American Affairs
            </a>
            , and{' '}
            <a
              href='https://americancompass.org/unleash-the-techno-industrial-state/'
              target='_blank'
              rel='noopener noreferrer'
            >
              American Compass.
            </a>
          </p>

          <p>I'm currently interested in:</p>
          <ul className='intro-topics'>
            <li>Why theology needs history</li>
            <li>How to raise humble & exceptional kids</li>
            <li>Ancient Chinese statecraft (475 BC - 280 AD)</li>
            <li>The future of economic populism and spiritual revival</li>
          </ul>
          <p>
            Reach out if you'd like to trade notes:{' '}
            <code className='email'>
              \".\".join([\"moc\",\"liamg@lanosrep.uy.nivlek\"])[::-1]
            </code>
          </p>
        </section>
        <hr className='section-divider' />
        <section className='essays'>
          <h2>Work & Writing</h2>
          <ul>
            <li>
              <a
                href='http://rebuilding.tech/'
                target='_blank'
                rel='noopener noreferrer'
              >
                Rebuilding America: The Techno-Industrial Policy Playbook
              </a>
            </li>
            <li>
              <a
                href='http://rebuilding.tech/foreword/'
                target='_blank'
                rel='noopener noreferrer'
              >
                America's Techno-Industrial Crossroads
              </a>
            </li>
            <li>
              <a
                href='https://science.house.gov/2023/6/artificial-intelligence-advancing-innovation-towards-the-national-interest'
                target='_blank'
                rel='noopener noreferrer'
              >
                Congressional Hearing: Advancing Innovation Towards the National
                Interest
              </a>
            </li>
            <li>
              <a
                href='https://kelvinotcelsius.substack.com/p/atomic-transactions-where-is-my-flying'
                target='_blank'
                rel='noopener noreferrer'
              >
                Atomic Transactions: Why Some Deeptech Categories Fail More Than
                Others
              </a>
            </li>
            <li>
              <a
                href='https://americanaffairsjournal.org/2025/02/technological-progress-in-chinese-political-culture-an-intellectual-genealogy/'
                target='_blank'
                rel='noopener noreferrer'
              >
                Technological Progress in Chinese Political Culture
              </a>
            </li>
            <li>
              <a
                href='https://kelvinotcelsius.substack.com/p/agentic-theories-of-history-and-the'
                target='_blank'
                rel='noopener noreferrer'
              >
                Anti-Agentic Theories of History: The False Seduction of
                Cyclicality
              </a>
            </li>
            <li>
              <a
                href='https://kelvinotcelsius.substack.com/p/notes-from-the-underground-founder'
                target='_blank'
                rel='noopener noreferrer'
              >
                Notes from the Underground Founder: Silicon Valley
                Superfluousness
              </a>
            </li>
            {/* <li>
              <a
                href='https://americancompass.org/unleash-the-techno-industrial-state/'
                target='_blank'
                rel='noopener noreferrer'
              >
                Unleash the Techno-Industrial State
              </a>
            </li> */}
            <li>
              <a
                href='https://www.leversforprogress.com'
                target='_blank'
                rel='noopener noreferrer'
              >
                Levers for Progress: How States Can Advance Science and
                Technology
              </a>
            </li>
            <a
              href='http://rebuilding.tech/'
              target='_blank'
              rel='noopener noreferrer'
            >
              <img
                src={require('../../assets/images/playbook.png')}
                alt='Rebuilding America: The Techno-Industrial Policy Playbook'
                style={{ height: '15em', width: 'auto' }}
              />
            </a>
          </ul>
        </section>
      </main>
    </div>
  );
}

export default App;
